import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DefaultSelectV2 from '../DefaultSelectV2';
import MultiSelectV2 from '../MultiSelectV2';
import { getNsirStatusSelectOptions } from '../../../constants/status';

const NsirStatusSelectV2 = ({ onSelect, value, isRequired, disabled, isMultiple, options }) => {
  const handleMultiplo = newValue => {
    let result = null;
    if (newValue) { result = newValue.map(v => v.value); }
    onSelect(result);
  }

  const [defaultOptions, setDefaultOptions] = useState(() => getNsirStatusSelectOptions());

  useEffect(() => {
    if (options) setDefaultOptions(options);
  }, [options]);

  return (
    <>
      { isMultiple ? 
        <MultiSelectV2
          label="Status"
          onChange={newValue => handleMultiplo(newValue)}
          defaultValue={defaultOptions && value ? defaultOptions.filter(p => value.indexOf(p.id) > -1).map(i => ({ value: i.id, label: i['nome'] })) : []}
          options={defaultOptions ? defaultOptions.map(i => ({ value: i.id, label: i['nome'] })) : []}
        /> 
        :
        <DefaultSelectV2 
          isRequired={isRequired} label="Status"
          onSelect={event => onSelect(event.target.value)}
          options={defaultOptions} value={value} disabled={disabled}
        />
      }
    </>
  );
}

NsirStatusSelectV2.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isRequired: PropTypes.any, disabled: PropTypes.bool, onSelect: PropTypes.func,
  isMultiple: PropTypes.bool, options: PropTypes.array
};

NsirStatusSelectV2.defaultProps = {
  value: null, disabled: false, isRequired: false, isMultiple: false,
  onSelect: () => {}, options: null
};

export default NsirStatusSelectV2;
